// Writes a ComposeFormatting result into a <textarea> the way typing would: only the span that
// changed is replaced, through the browser's own editing (`insertText`), so the textarea's undo
// keeps it and its `input` event reaches React's onChange in the same turn. The selection is set
// right away — a caret parked a frame later (requestAnimationFrame) landed BEHIND letters typed in
// that frame ("linea tres" came out "a tresline" in the 2026-10-14 capture).
import type { Applied } from '../../core/composeFormatting';

export function writeThrough(el: HTMLTextAreaElement, applied: Applied): void {
  const old = el.value;
  const next = applied.text;
  let prefix = 0;
  while (prefix < old.length && prefix < next.length && old[prefix] === next[prefix]) prefix++;
  let suffix = 0;
  while (suffix < old.length - prefix && suffix < next.length - prefix && old[old.length - 1 - suffix] === next[next.length - 1 - suffix]) suffix++;
  const replacement = next.slice(prefix, next.length - suffix);
  if (prefix !== old.length || old.length !== next.length) {
    el.focus();
    el.setSelectionRange(prefix, old.length - suffix);
    const done = replacement === '' ? document.execCommand('delete') : document.execCommand('insertText', false, replacement);
    if (!done || el.value !== next) {
      // No editing command (an old engine): set the value and tell React like an input would.
      el.setRangeText(replacement, prefix, old.length - suffix, 'end');
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
  el.setSelectionRange(applied.selectionStart, applied.selectionEnd);
}
